(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[44],{

/***/ 5811:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/climate-leads",
      function () {
        return __webpack_require__(2258);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

function ArrowRight(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", _objectSpread({
        width: 11,
        height: 11,
        viewBox: "0 0 11 11",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        stroke: "white",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, props, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M5.72 10L10 5.5M10 5.5L5.72 1M10 5.5L1 5.5"
        })
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (ArrowRight);


/***/ }),

/***/ 2258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ EarthDayPage; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.7-canary.31_react-dom@17.0.2+react@17.0.2/node_modules/next/dist/shared/lib/styled-jsx.js
var styled_jsx = __webpack_require__(1614);
var styled_jsx_default = /*#__PURE__*/__webpack_require__.n(styled_jsx);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.7-canary.31_react-dom@17.0.2+react@17.0.2/node_modules/next/image.js
var next_image = __webpack_require__(6089);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.7-canary.31_react-dom@17.0.2+react@17.0.2/node_modules/next/link.js
var next_link = __webpack_require__(125);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/meta.tsx
var meta = __webpack_require__(1797);
// EXTERNAL MODULE: ./components/navbar.tsx + 1 modules
var navbar = __webpack_require__(9106);
// EXTERNAL MODULE: ./components/icons/arrow_right.tsx
var arrow_right = __webpack_require__(2072);
// EXTERNAL MODULE: ./components/footer.tsx
var footer = __webpack_require__(4898);
;// CONCATENATED MODULE: ./components/climate-leads/tile.png
/* harmony default export */ var tile = ({"src":"/_next/static/media/tile.d677161e.png","height":862,"width":862,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAA1BMVEVIbOXA29P+AAAACXBIWXMAABYlAAAWJQFJUiTwAAAADElEQVQImWNgoA4AAABIAAF7pRHIAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./components/climate-leads/textured-earth-full.webp
/* harmony default export */ var textured_earth_full = ({"src":"/_next/static/media/textured-earth-full.be71cda5.webp","height":1582,"width":3908,"blurDataURL":"data:image/webp;base64,UklGRoYAAABXRUJQVlA4WAoAAAAQAAAABwAAAgAAQUxQSBkAAAAApZiAUhoBAAD/////9dBvGP/////////0AFZQOCBGAAAA0AEAnQEqCAADAAJAOCWwAnQBDtZtb8AA/fApbSLfowOaH2+P1oJ/aibbkg/K+UH/jnFKgft9m5Y/2sLgwn3ZusnHZFFQAA=="});
;// CONCATENATED MODULE: ./components/climate-leads/customer-airbnb.svg
/* harmony default export */ var customer_airbnb = ({"src":"/_next/static/media/customer-airbnb.5be9c1ed.svg","height":780,"width":2500});
;// CONCATENATED MODULE: ./components/climate-leads/company.tsx



function Company(param) {
    var name = param.name, logo = param.logo, diagram = param.diagram, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
        className: "jsx-f149369b9f3c246",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "jsx-f149369b9f3c246",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "https://".concat(name.replace(" ", "").toLowerCase(), ".com"),
                    target: "_blank",
                    rel: "noreferrer noopener",
                    className: "jsx-f149369b9f3c246",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: logo,
                        objectFit: "contain",
                        objectPosition: "left center",
                        alt: "".concat(name, " logo")
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "jsx-f149369b9f3c246",
                children: children
            }),
            diagram && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "jsx-f149369b9f3c246" + " " + "diagram",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: diagram,
                    alt: "Diagram"
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "f149369b9f3c246",
                children: "div.jsx-f149369b9f3c246{padding-block:24px;border-top:1px dashed var(--color-core-cobalt)}div.jsx-f149369b9f3c246:last-child{border-bottom:1px dashed var(--color-core-cobalt)}a.jsx-f149369b9f3c246{display:block;line-height:0}a.jsx-f149369b9f3c246>span{height:48px!important;max-width:min(66%,200px)!important}aside.jsx-f149369b9f3c246 p{font-weight:600;font-size:18px;line-height:27px;color:var(--color-deep-cobalt);letter-spacing:0}.diagram.jsx-f149369b9f3c246{padding:24px 0}@media(max-width:520px){aside.jsx-f149369b9f3c246{grid-row:4;padding-inline:16px;margin-block:48px}aside.jsx-f149369b9f3c246 p{padding-right:8px}.diagram.jsx-f149369b9f3c246:last-child{background:#f3f7ff;margin:32px -32px;padding:24px;border:0}}@media(min-width:820px){aside.jsx-f149369b9f3c246{margin-top:-16px}}"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/climate-leads/interview_ameet.mdx
/*@jsxRuntime automatic @jsxImportSource react*/ 


function MDXContent() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _createMdxContent = function _createMdxContent() {
        var _components = Object.assign({
            p: "p",
            strong: "strong",
            blockquote: "blockquote"
        }, props.components), Header = _components.Header;
        if (!Header) _missingMdxReference("Header", true);
        return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                (0,jsx_runtime.jsxs)("article", {
                    children: [
                        (0,jsx_runtime.jsx)(Header, {}),
                        (0,jsx_runtime.jsxs)(_components.p, {
                            children: [
                                (0,jsx_runtime.jsx)(_components.strong, {
                                    children: "I\u2019ve learned:"
                                }),
                                " The opportunity on climate is so vast that the key part is identifying how to keep moving the ball forward\u2014breaking big ideas down into concrete next steps so we can take immediate actions that move us toward our goals."
                            ]
                        }),
                        (0,jsx_runtime.jsxs)(_components.p, {
                            children: [
                                (0,jsx_runtime.jsx)(_components.strong, {
                                    children: "My role:"
                                }),
                                " Leveraging existing structures, sustainability has long been part of Airbnb\u2019s history, and remains an important focus for Hosts and guests around the world. My role was created to take our opportunity to the next level, for our company and in partnership with our global community."
                            ]
                        }),
                        (0,jsx_runtime.jsxs)(_components.p, {
                            children: [
                                (0,jsx_runtime.jsx)(_components.strong, {
                                    children: "I want others to know:"
                                }),
                                " Even small individual changes add up when applied to millions of people. When you enter the climate space, it\u2019s easy to look around and say \u201Cit\u2019s too big,\u201D \u201Cit\u2019s too late,\u201D or \u201Cwhat can I really add.\u201D It\u2019s about our collective power, and that each of us doing our part can make a real difference."
                            ]
                        })
                    ]
                }),
                "\n",
                (0,jsx_runtime.jsxs)(Company, {
                    name: "Airbnb",
                    logo: customer_airbnb,
                    children: [
                        (0,jsx_runtime.jsx)(_components.p, {
                            children: "A global community based on connection and belonging, where Hosts and guests can be catalysts for sustainable activity in their communities."
                        }),
                        (0,jsx_runtime.jsx)(_components.p, {
                            children: "Already matching 100% of corporate electricity with renewable energy and committed to a net-zero corporate footprint by 2030."
                        })
                    ]
                }),
                "\n",
                (0,jsx_runtime.jsxs)(_components.blockquote, {
                    children: [
                        "\n",
                        (0,jsx_runtime.jsxs)(_components.p, {
                            children: [
                                "It\u2019s not about adding \u2018and what about sustainability\u2019 as an afterthought; it\u2019s about partnering to ",
                                (0,jsx_runtime.jsx)("mark", {
                                    children: "embed sustainability as a decision-making criteria"
                                }),
                                "."
                            ]
                        }),
                        "\n"
                    ]
                })
            ]
        });
    };
    var ref = props.components || {}, MDXLayout = ref.wrapper;
    return MDXLayout ? (0,jsx_runtime.jsx)(MDXLayout, Object.assign({}, props, {
        children: (0,jsx_runtime.jsx)(_createMdxContent, {})
    })) : _createMdxContent();
}
/* harmony default export */ var interview_ameet = (MDXContent);
function _missingMdxReference(id, component) {
    throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

;// CONCATENATED MODULE: ./components/climate-leads/customer-boom.svg
/* harmony default export */ var customer_boom = ({"src":"/_next/static/media/customer-boom.7c1d8269.svg","height":57,"width":224});
;// CONCATENATED MODULE: ./components/climate-leads/diagram-boom.svg
/* harmony default export */ var diagram_boom = ({"src":"/_next/static/media/diagram-boom.836aa6f8.svg","height":302,"width":348});
;// CONCATENATED MODULE: ./components/climate-leads/interview_ben.mdx
/*@jsxRuntime automatic @jsxImportSource react*/ 



function interview_ben_MDXContent() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _createMdxContent = function _createMdxContent() {
        var _components = Object.assign({
            p: "p",
            strong: "strong",
            a: "a",
            blockquote: "blockquote"
        }, props.components), Header = _components.Header;
        if (!Header) interview_ben_missingMdxReference("Header", true);
        return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                (0,jsx_runtime.jsxs)("article", {
                    children: [
                        (0,jsx_runtime.jsx)(Header, {}),
                        (0,jsx_runtime.jsxs)(_components.p, {
                            children: [
                                (0,jsx_runtime.jsx)(_components.strong, {
                                    children: "A typical week:"
                                }),
                                " Typical doesn\u2019t really exist when there are so many facets to achieving ",
                                (0,jsx_runtime.jsx)(_components.a, {
                                    href: "https://boomsupersonic.com/sustainability",
                                    children: "sustainable supersonic flight"
                                }),
                                "! I jump from improving our data quality for next year\u2019s emissions accounting to advocating for policies that accelerate net-zero carbon fuels to working on ",
                                (0,jsx_runtime.jsx)(_components.a, {
                                    href: "https://www.prometheusfuels.com/",
                                    children: "partnerships for plasma-assisted combustion"
                                }),
                                " to reduce emissions."
                            ]
                        }),
                        (0,jsx_runtime.jsxs)(_components.p, {
                            children: [
                                (0,jsx_runtime.jsx)(_components.strong, {
                                    children: "Our approach:"
                                }),
                                " We\u2019re working to remove the barriers to travel\u2014not just the time it takes, but also the environmental impacts. Climate strongly informs our evaluation of customers and suppliers, and having set an internal cost of carbon helps us make data-driven, environmentally-conscious decisions."
                            ]
                        }),
                        (0,jsx_runtime.jsxs)(_components.p, {
                            children: [
                                (0,jsx_runtime.jsx)(_components.strong, {
                                    children: "I\u2019m proud of:"
                                }),
                                " Achieving carbon neutrality beginning in 2021 and publishing our first annual sustainability report in the next few weeks."
                            ]
                        }),
                        (0,jsx_runtime.jsxs)(_components.p, {
                            children: [
                                (0,jsx_runtime.jsx)(_components.strong, {
                                    children: "I\u2019m optimistic because:"
                                }),
                                " Even though aviation is a challenging sector to decarbonize, the rapid acceleration of sustainable aviation fuels over the past few years clearly shows that the future of aviation really will be sustainable. This isn\u2019t yesteryear\u2019s bio fuel, it\u2019s a forward looking technology\u2014pulling CO",
                                (0,jsx_runtime.jsx)("sub", {
                                    children: "2"
                                }),
                                " directly from the air to create net zero carbon fuel."
                            ]
                        })
                    ]
                }),
                "\n",
                (0,jsx_runtime.jsxs)(Company, {
                    name: "Boom Supersonic",
                    logo: customer_boom,
                    diagram: diagram_boom,
                    children: [
                        (0,jsx_runtime.jsx)(_components.p, {
                            children: "Working to make travel faster, cleaner, and more beneficial to communities\u2014creating a new model for strategic sustainability in aviation."
                        }),
                        (0,jsx_runtime.jsx)(_components.p, {
                            children: "They didn\u2019t just tack on a climate program; they wove climate thinking into their DNA from day one."
                        })
                    ]
                }),
                "\n",
                (0,jsx_runtime.jsxs)(_components.blockquote, {
                    children: [
                        "\n",
                        (0,jsx_runtime.jsxs)(_components.p, {
                            children: [
                                "Boom is working not just to be a leader in decarbonizing aviation, but to also ",
                                (0,jsx_runtime.jsx)("mark", {
                                    children: "drive systematic change across the entire industry"
                                }),
                                "."
                            ]
                        }),
                        "\n"
                    ]
                })
            ]
        });
    };
    var ref = props.components || {}, MDXLayout = ref.wrapper;
    return MDXLayout ? (0,jsx_runtime.jsx)(MDXLayout, Object.assign({}, props, {
        children: (0,jsx_runtime.jsx)(_createMdxContent, {})
    })) : _createMdxContent();
}
/* harmony default export */ var interview_ben = (interview_ben_MDXContent);
function interview_ben_missingMdxReference(id, component) {
    throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

;// CONCATENATED MODULE: ./components/climate-leads/customer-spotify.svg
/* harmony default export */ var customer_spotify = ({"src":"/_next/static/media/customer-spotify.539eeb5a.svg","height":2931,"width":9772});
;// CONCATENATED MODULE: ./components/climate-leads/diagram-spotify.svg
/* harmony default export */ var diagram_spotify = ({"src":"/_next/static/media/diagram-spotify.7050988f.svg","height":203,"width":383});
;// CONCATENATED MODULE: ./components/climate-leads/interview_ebba.mdx
/*@jsxRuntime automatic @jsxImportSource react*/ 



function interview_ebba_MDXContent() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _createMdxContent = function _createMdxContent() {
        var _components = Object.assign({
            p: "p",
            strong: "strong",
            a: "a",
            blockquote: "blockquote"
        }, props.components), Header = _components.Header;
        if (!Header) interview_ebba_missingMdxReference("Header", true);
        return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                (0,jsx_runtime.jsxs)("article", {
                    children: [
                        (0,jsx_runtime.jsx)(Header, {}),
                        (0,jsx_runtime.jsxs)(_components.p, {
                            children: [
                                (0,jsx_runtime.jsx)(_components.strong, {
                                    children: "Our approach:"
                                }),
                                " In addition to working towards net zero, we\u2019re focused on using the reach of our platform to both raise awareness of the climate crisis and drive positive change. Whether that\u2019s through the ",
                                (0,jsx_runtime.jsx)(_components.a, {
                                    href: "https://open.spotify.com/show/1tEMiFKer7YS2A6mhbmWE1?si=230abb0a2d464e03",
                                    children: "podcasts we recorded at COP26"
                                }),
                                " last November, all the content in our ",
                                (0,jsx_runtime.jsx)(_components.a, {
                                    href: "https://open.spotify.com/genre/play_your_part_climate-page",
                                    children: "Climate Action Hub"
                                }),
                                ", or this year\u2019s Earth Day campaign amplifying the voices of young climate advocates across the world."
                            ]
                        }),
                        (0,jsx_runtime.jsxs)(_components.p, {
                            children: [
                                (0,jsx_runtime.jsx)(_components.strong, {
                                    children: "I believe:"
                                }),
                                " Sustainability shouldn\u2019t be handled on the side. To get people factoring climate into everyday decision-making, you need clear direction and a plan on how you\u2019re going to educate teams on the challenges and make the relevant data available for all to use. Integration is the only way to drive impact for real."
                            ]
                        }),
                        (0,jsx_runtime.jsxs)(_components.p, {
                            children: [
                                (0,jsx_runtime.jsx)(_components.strong, {
                                    children: "I\u2019m proud that:"
                                }),
                                " We have great climate engagement across the company. Our R&D team set up a Climate Champions network to drive goal-setting and implementation. We also had climate as our theme for our annual Hack Week this year to harness the creativity of all Spotifiers. We love experimentation and seeing what works."
                            ]
                        })
                    ]
                }),
                "\n",
                (0,jsx_runtime.jsxs)(Company, {
                    name: "Spotify",
                    logo: customer_spotify,
                    diagram: diagram_spotify,
                    children: [
                        (0,jsx_runtime.jsx)(_components.p, {
                            children: "Unlocking the potential of human creativity by helping creative artists earn from their art\u2014including climate storytelling."
                        }),
                        (0,jsx_runtime.jsx)(_components.p, {
                            children: "On a path to net zero by 2030, including all supplier (Scope 3) emissions."
                        })
                    ]
                }),
                "\n",
                (0,jsx_runtime.jsxs)(_components.blockquote, {
                    children: [
                        "\n",
                        (0,jsx_runtime.jsxs)(_components.p, {
                            children: [
                                "Many of the solutions needed to solve the climate crisis already exist. ",
                                (0,jsx_runtime.jsx)("mark", {
                                    children: "We just need to find ways to implement them"
                                }),
                                " at scale."
                            ]
                        }),
                        "\n"
                    ]
                })
            ]
        });
    };
    var ref = props.components || {}, MDXLayout = ref.wrapper;
    return MDXLayout ? (0,jsx_runtime.jsx)(MDXLayout, Object.assign({}, props, {
        children: (0,jsx_runtime.jsx)(_createMdxContent, {})
    })) : _createMdxContent();
}
/* harmony default export */ var interview_ebba = (interview_ebba_MDXContent);
function interview_ebba_missingMdxReference(id, component) {
    throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

;// CONCATENATED MODULE: ./components/climate-leads/customer-everlane.svg
/* harmony default export */ var customer_everlane = ({"src":"/_next/static/media/customer-everlane.b6dd5796.svg","height":57,"width":600});
;// CONCATENATED MODULE: ./components/climate-leads/interview_kim.mdx
/*@jsxRuntime automatic @jsxImportSource react*/ 


function interview_kim_MDXContent() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _createMdxContent = function _createMdxContent() {
        var _components = Object.assign({
            p: "p",
            strong: "strong",
            blockquote: "blockquote"
        }, props.components), Header = _components.Header;
        if (!Header) interview_kim_missingMdxReference("Header", true);
        return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                (0,jsx_runtime.jsxs)("article", {
                    children: [
                        (0,jsx_runtime.jsx)(Header, {}),
                        (0,jsx_runtime.jsxs)(_components.p, {
                            children: [
                                (0,jsx_runtime.jsx)(_components.strong, {
                                    children: "A typical week:"
                                }),
                                " We\u2019re in the midst of rethinking the look and story of our products, and of finalizing our first impact report. But we also have weekly carbon meetings based on the insights we get from Watershed, and are constantly thinking about how to streamline our global supply chain."
                            ]
                        }),
                        (0,jsx_runtime.jsxs)(_components.p, {
                            children: [
                                (0,jsx_runtime.jsx)(_components.strong, {
                                    children: "My career path:"
                                }),
                                " I don\u2019t have a background in apparel or climate. I\u2019d planned to be an orthopedic surgeon! When I started here, the company was approximately 25-30 people and very few brands in the industry were talking about sustainability\u2014and now my team alone is larger than that. I don\u2019t think it matters what your education or background is. Being a good sustainability champion is about being inquisitive: asking good questions and actively listening."
                            ]
                        }),
                        (0,jsx_runtime.jsxs)(_components.p, {
                            children: [
                                (0,jsx_runtime.jsx)(_components.strong, {
                                    children: "I\u2019m optimistic because:"
                                }),
                                " It takes work to stay positive right now. Supply chains are in a tough place. But this new attention has upsides: our grandparents are talking about supply chains and container ships now, and there\u2019s a much greater understanding of supply chain impact. And this impact can be positive, where every positive change ripples across the world."
                            ]
                        })
                    ]
                }),
                "\n",
                (0,jsx_runtime.jsxs)(Company, {
                    name: "Everlane",
                    logo: customer_everlane,
                    children: [
                        (0,jsx_runtime.jsx)(_components.p, {
                            children: "Bringing radical transparency to the fashion industry to help customers make informed decisions around ethics and sustainability."
                        }),
                        (0,jsx_runtime.jsx)(_components.p, {
                            children: "Working with the Science Based Targets initiative (SBTi) to ensure they\u2019re cutting their full share of emissions."
                        })
                    ]
                }),
                "\n",
                (0,jsx_runtime.jsxs)(_components.blockquote, {
                    children: [
                        "\n",
                        (0,jsx_runtime.jsxs)(_components.p, {
                            children: [
                                "Sustainability isn\u2019t just a cost now. The industry is able to use it as ",
                                (0,jsx_runtime.jsx)("mark", {
                                    children: "a revenue and a growth vehicle"
                                }),
                                "."
                            ]
                        }),
                        "\n"
                    ]
                })
            ]
        });
    };
    var ref = props.components || {}, MDXLayout = ref.wrapper;
    return MDXLayout ? (0,jsx_runtime.jsx)(MDXLayout, Object.assign({}, props, {
        children: (0,jsx_runtime.jsx)(_createMdxContent, {})
    })) : _createMdxContent();
}
/* harmony default export */ var interview_kim = (interview_kim_MDXContent);
function interview_kim_missingMdxReference(id, component) {
    throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

;// CONCATENATED MODULE: ./components/climate-leads/customer-pinterest.svg
/* harmony default export */ var customer_pinterest = ({"src":"/_next/static/media/customer-pinterest.f7af29de.svg","height":100,"width":100});
;// CONCATENATED MODULE: ./components/climate-leads/interview_mia.mdx
/*@jsxRuntime automatic @jsxImportSource react*/ 


function interview_mia_MDXContent() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _createMdxContent = function _createMdxContent() {
        var _components = Object.assign({
            p: "p",
            strong: "strong",
            blockquote: "blockquote"
        }, props.components), Header = _components.Header;
        if (!Header) interview_mia_missingMdxReference("Header", true);
        return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                (0,jsx_runtime.jsxs)("article", {
                    children: [
                        (0,jsx_runtime.jsx)(Header, {}),
                        (0,jsx_runtime.jsxs)(_components.p, {
                            children: [
                                (0,jsx_runtime.jsx)(_components.strong, {
                                    children: "My day job:"
                                }),
                                " I gather data about our environmental impact, translate it into meaningful insights for my cross-functional partners, and help them develop plans to reduce our footprint."
                            ]
                        }),
                        (0,jsx_runtime.jsxs)(_components.p, {
                            children: [
                                (0,jsx_runtime.jsx)(_components.strong, {
                                    children: "My climate background:"
                                }),
                                " I\u2019d been doing aspects of this work for a long time before I got the formal title. I\u2019ve always been passionate about the role the private sector can and should play in addressing the climate crisis, and I\u2019m motivated by the scale of impact we can have as a company."
                            ]
                        }),
                        (0,jsx_runtime.jsxs)(_components.p, {
                            children: [
                                (0,jsx_runtime.jsx)(_components.strong, {
                                    children: "My approach:"
                                }),
                                " I tailor my communication to make it clear how day-to-day decisions make an impact, what\u2019s at stake, and how everyone can play a role. My goal is to connect with as many people here as possible so that I can understand their priorities and we can figure out how to incorporate a sustainability mindset into their work."
                            ]
                        })
                    ]
                }),
                "\n",
                (0,jsx_runtime.jsxs)(Company, {
                    name: "Pinterest",
                    logo: customer_pinterest,
                    children: [
                        (0,jsx_runtime.jsx)(_components.p, {
                            children: "Helping people discover things they love, and inspiring them to go do those things in their daily lives\u2014including pro-climate activities they might have not considered before."
                        }),
                        (0,jsx_runtime.jsx)(_components.p, {
                            children: "Using data to drive sustainable decision-making in all aspects\u2014including facilities, vendors, and employee food choices."
                        })
                    ]
                }),
                "\n",
                (0,jsx_runtime.jsxs)(_components.blockquote, {
                    children: [
                        "\n",
                        (0,jsx_runtime.jsxs)(_components.p, {
                            children: [
                                "Climate work is an opportunity to think 5, 10, 15 years into the future about ",
                                (0,jsx_runtime.jsx)("mark", {
                                    children: "how the decisions we make today will build a better tomorrow"
                                }),
                                "."
                            ]
                        }),
                        "\n"
                    ]
                })
            ]
        });
    };
    var ref = props.components || {}, MDXLayout = ref.wrapper;
    return MDXLayout ? (0,jsx_runtime.jsx)(MDXLayout, Object.assign({}, props, {
        children: (0,jsx_runtime.jsx)(_createMdxContent, {})
    })) : _createMdxContent();
}
/* harmony default export */ var interview_mia = (interview_mia_MDXContent);
function interview_mia_missingMdxReference(id, component) {
    throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

;// CONCATENATED MODULE: ./components/climate-leads/customer-aledade.png
/* harmony default export */ var customer_aledade = ({"src":"/_next/static/media/customer-aledade.5e882de4.png","height":348,"width":1000,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAG1BMVEUoVn86rdwIX4xAUHX/EBIlV4BjRGLHJzVKTG4GXYplAAAACXRSTlMUAjohC0MuMVaIef11AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIElEQVQImWNgZGBmZGFhZGRgZOVgZgABdjZmJiYmJlYAAv8APlmD158AAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./components/climate-leads/interview_will.mdx
/*@jsxRuntime automatic @jsxImportSource react*/ 


function interview_will_MDXContent() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _createMdxContent = function _createMdxContent() {
        var _components = Object.assign({
            p: "p",
            strong: "strong",
            a: "a",
            em: "em",
            blockquote: "blockquote"
        }, props.components), Header = _components.Header;
        if (!Header) interview_will_missingMdxReference("Header", true);
        return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                (0,jsx_runtime.jsxs)("article", {
                    children: [
                        (0,jsx_runtime.jsx)(Header, {}),
                        (0,jsx_runtime.jsxs)(_components.p, {
                            children: [
                                (0,jsx_runtime.jsx)(_components.strong, {
                                    children: "My day job:"
                                }),
                                " Democratizing data access for others at my company. But I volunteered in 2020 to have a twin focus on climate. So one moment I\u2019m handling SQL queries and the next I\u2019m asking how we can help ",
                                (0,jsx_runtime.jsx)(_components.a, {
                                    href: "https://resources.aledade.com/aco-show-podcasts/episode-98-turning-your-practice-green",
                                    children: "primary care physicians switch to clean energy"
                                }),
                                "."
                            ]
                        }),
                        (0,jsx_runtime.jsxs)(_components.p, {
                            children: [
                                (0,jsx_runtime.jsx)(_components.strong, {
                                    children: "My climate background:"
                                }),
                                " I didn\u2019t take any environmental classes in college. I just didn\u2019t see how I had an opportunity to make a difference. But it turns out the corporate world is full of opportunities. And the more I invested into understanding them, the more my ambition for Aledade\u2019s climate program grew, and the more trust I was given."
                            ]
                        }),
                        (0,jsx_runtime.jsxs)(_components.p, {
                            children: [
                                (0,jsx_runtime.jsx)(_components.strong, {
                                    children: "I\u2019m proud of:"
                                }),
                                " Over just the last year, we gained a granular understanding of our emissions, achieved ",
                                (0,jsx_runtime.jsx)(_components.a, {
                                    href: "https://resources.aledade.com/press-releases/aledade-announces-carbon-neutrality-additional-sustainability-efforts",
                                    children: "carbon neutrality"
                                }),
                                ", and began switching over to clean energy. And we\u2019re now already increasing our carbon removal investments ",
                                (0,jsx_runtime.jsx)(_components.em, {
                                    children: "by 6-7x"
                                }),
                                ". This is progress that used to take companies several years."
                            ]
                        }),
                        (0,jsx_runtime.jsxs)(_components.p, {
                            children: [
                                (0,jsx_runtime.jsx)(_components.strong, {
                                    children: "I want others to know:"
                                }),
                                " You can do this work too! We started our climate program with zero expertise and just an inkling of an idea. There\u2019s a whole community of people out there willing to collaborate, and teams like Watershed to help you navigate the unknowns."
                            ]
                        })
                    ]
                }),
                "\n",
                (0,jsx_runtime.jsxs)(Company, {
                    name: "Aledade",
                    logo: customer_aledade,
                    children: [
                        (0,jsx_runtime.jsx)(_components.p, {
                            children: "Keeping people healthier and out of hospitals\u2014the second most energy-intensive building type in the US."
                        }),
                        (0,jsx_runtime.jsx)(_components.p, {
                            children: "Created a best-in-class carbon removal portfolio before other companies were thinking about it."
                        })
                    ]
                }),
                "\n",
                (0,jsx_runtime.jsxs)(_components.blockquote, {
                    children: [
                        "\n",
                        (0,jsx_runtime.jsxs)(_components.p, {
                            children: [
                                "Most companies are now realizing that ",
                                (0,jsx_runtime.jsx)("mark", {
                                    children: "climate\xa0work is aligned with their mission and long-term goals"
                                }),
                                "."
                            ]
                        }),
                        "\n"
                    ]
                })
            ]
        });
    };
    var ref = props.components || {}, MDXLayout = ref.wrapper;
    return MDXLayout ? (0,jsx_runtime.jsx)(MDXLayout, Object.assign({}, props, {
        children: (0,jsx_runtime.jsx)(_createMdxContent, {})
    })) : _createMdxContent();
}
/* harmony default export */ var interview_will = (interview_will_MDXContent);
function interview_will_missingMdxReference(id, component) {
    throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

;// CONCATENATED MODULE: ./components/climate-leads/avatar-ameet.webp
/* harmony default export */ var avatar_ameet = ({"src":"/_next/static/media/avatar-ameet.09f79960.webp","height":546,"width":546,"blurDataURL":"data:image/webp;base64,UklGRlgAAABXRUJQVlA4IEwAAADwAQCdASoIAAgAAkA4JbACdAYoBbYMswAA/gekP2ioPrk734+5NyGOvqmKk2yDrxf2r2I1JEHNiv7hX5z+uSnqgrXV65yWHbjdAAAA"});
;// CONCATENATED MODULE: ./components/climate-leads/avatar-ben.webp
/* harmony default export */ var avatar_ben = ({"src":"/_next/static/media/avatar-ben.adf22866.webp","height":546,"width":546,"blurDataURL":"data:image/webp;base64,UklGRmIAAABXRUJQVlA4IFYAAADQAQCdASoIAAgAAkA4JagCdG1/AjIoAAD+xc1GgCQnl+jGt+CEo9FEbSn2IfWzNJ+02WMH6ceS8orF5KH5Ghxep0r9sHH/Owg/v5XZcGwOq+mUfQAAAA=="});
;// CONCATENATED MODULE: ./components/climate-leads/avatar-ebba.webp
/* harmony default export */ var avatar_ebba = ({"src":"/_next/static/media/avatar-ebba.c968fe6a.webp","height":546,"width":546,"blurDataURL":"data:image/webp;base64,UklGRmoAAABXRUJQVlA4IF4AAAAQAgCdASoIAAgAAkA4JaACdAEfUoaEdw4AAP6J8N7e0XveB3publf8LtYje82x+ebBK2bKeurfefPWOvBGsaX7/PafKeT+uTA6z7bhHng0+Gr7hZnS5Ywr4wiE7AAA"});
;// CONCATENATED MODULE: ./components/climate-leads/avatar-kim.webp
/* harmony default export */ var avatar_kim = ({"src":"/_next/static/media/avatar-kim.b6867111.webp","height":546,"width":546,"blurDataURL":"data:image/webp;base64,UklGRlwAAABXRUJQVlA4IFAAAADwAQCdASoIAAgAAkA4JbACdAEW08eB34AA/gDq/rQVqsap6Yx/2Ib0ixp3ODlkSSuTWwXys5+LWVBCLg5zFkjZP9nc7/in+bsg7wbka/SsAA=="});
;// CONCATENATED MODULE: ./components/climate-leads/avatar-mia.webp
/* harmony default export */ var avatar_mia = ({"src":"/_next/static/media/avatar-mia.191bc1c0.webp","height":546,"width":546,"blurDataURL":"data:image/webp;base64,UklGRlQAAABXRUJQVlA4IEgAAACwAQCdASoIAAgAAkA4JaACdADdDAqQAP7rochVEaYSl2SNap1x+ZY+26W+dyqB941P4sOSl4Msf1p3BN91q9jyG6qrAldAAAA="});
;// CONCATENATED MODULE: ./components/climate-leads/avatar-will.webp
/* harmony default export */ var avatar_will = ({"src":"/_next/static/media/avatar-will.1b3111c4.webp","height":546,"width":546,"blurDataURL":"data:image/webp;base64,UklGRloAAABXRUJQVlA4IE4AAACwAQCdASoIAAgAAkA4JbACdADc5dHAAP7I7g6DMtoSCWm+L2CTmFo3C+lS1kYtiNnKEnEuMWOWU7q13x3/h1W/tR+cVQwS4PM9LZt8gAA="});
;// CONCATENATED MODULE: ./components/climate-leads/icon-airbnb.svg
/* harmony default export */ var icon_airbnb = ({"src":"/_next/static/media/icon-airbnb.00d758f8.svg","height":75,"width":75});
;// CONCATENATED MODULE: ./components/climate-leads/icon-aledade.svg
/* harmony default export */ var icon_aledade = ({"src":"/_next/static/media/icon-aledade.6bd21c45.svg","height":76,"width":76});
;// CONCATENATED MODULE: ./components/climate-leads/icon-boom.svg
/* harmony default export */ var icon_boom = ({"src":"/_next/static/media/icon-boom.a04f103e.svg","height":75,"width":75});
;// CONCATENATED MODULE: ./components/climate-leads/icon-everlane.svg
/* harmony default export */ var icon_everlane = ({"src":"/_next/static/media/icon-everlane.b6015d26.svg","height":75,"width":75});
;// CONCATENATED MODULE: ./components/climate-leads/icon-pinterest.svg
/* harmony default export */ var icon_pinterest = ({"src":"/_next/static/media/icon-pinterest.3db93f97.svg","height":75,"width":75});
;// CONCATENATED MODULE: ./components/climate-leads/icon-spotify.svg
/* harmony default export */ var icon_spotify = ({"src":"/_next/static/media/icon-spotify.0367a78d.svg","height":75,"width":75});
;// CONCATENATED MODULE: ./pages/climate-leads.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}




























var people = {
    ameet: {
        avatar: avatar_ameet,
        name: "Ameet Konkar",
        role: "Head of Sustainability",
        interview: interview_ameet
    },
    mia: {
        avatar: avatar_mia,
        name: "Mia Ketterling",
        role: "Workplace Sustainability Manager",
        interview: interview_mia
    },
    ben: {
        avatar: avatar_ben,
        name: "Ben Murphy",
        role: "Head of Sustainability Policy",
        interview: interview_ben
    },
    ebba: {
        avatar: avatar_ebba,
        name: "Ebba Grythberg",
        role: "Global Sustainability Manager",
        interview: interview_ebba
    },
    kim: {
        avatar: avatar_kim,
        name: "Kimberley Smith",
        role: "Chief Supply Chain Officer",
        interview: interview_kim
    },
    will: {
        avatar: avatar_will,
        name: "Will Palmisano",
        role: "Senior Product Analyst",
        interview: interview_will
    }
};
var companies = {
    airbnb: {
        name: "Airbnb",
        icon: icon_airbnb,
        person: people.ameet
    },
    everlane: {
        name: "Everlane",
        icon: icon_everlane,
        person: people.kim
    },
    boom: {
        name: "Boom Supersonic",
        icon: icon_boom,
        person: people.ben
    },
    aledade: {
        name: "Aledade",
        icon: icon_aledade,
        person: people.will
    },
    pinterest: {
        name: "Pinterest",
        icon: icon_pinterest,
        person: people.mia
    },
    spotify: {
        name: "Spotify",
        icon: icon_spotify,
        person: people.ebba
    }
};
function TOC() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        className: "jsx-1d2be9d99620c2cd" + " " + "toc",
        children: [
            Object.entries(companies).map(function(param) {
                var _param = _slicedToArray(param, 2), id = _param[0], co = _param[1];
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "jsx-1d2be9d99620c2cd",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "#".concat(id),
                        onClick: function(e) {
                            if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
                                e.preventDefault();
                                document.querySelector("#".concat(id)).scrollIntoView({
                                    behavior: "smooth"
                                });
                            }
                        },
                        className: "jsx-1d2be9d99620c2cd",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "jsx-1d2be9d99620c2cd",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: co.icon.src,
                                    width: 75,
                                    height: 75,
                                    alt: co.name,
                                    className: "jsx-1d2be9d99620c2cd"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: co.person.avatar.src,
                                width: 75,
                                height: 75,
                                alt: co.person.name
                            })
                        ]
                    })
                }, id);
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "1d2be9d99620c2cd",
                children: "ul.jsx-1d2be9d99620c2cd{list-style:none;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;gap:10px;padding:0}li.jsx-1d2be9d99620c2cd{margin:0;background-color:#013aad;width:75px;height:75px;overflow:hidden;-webkit-border-radius:75px;-moz-border-radius:75px;border-radius:75px;line-height:0}img.jsx-1d2be9d99620c2cd{max-width:100%;max-height:100%}a.jsx-1d2be9d99620c2cd{display:grid}a.jsx-1d2be9d99620c2cd>span{-webkit-border-radius:75px;-moz-border-radius:75px;border-radius:75px;width:100%;height:100%}a.jsx-1d2be9d99620c2cd>span:last-child{display:none!important}@media(hover:hover)and (min-width:520px){a.jsx-1d2be9d99620c2cd>span{-webkit-transition:.5s -webkit-transform cubic-bezier(.85,0,.15,1);-moz-transition:.5s -moz-transform cubic-bezier(.85,0,.15,1);-o-transition:.5s -o-transform cubic-bezier(.85,0,.15,1);transition:.5s -webkit-transform cubic-bezier(.85,0,.15,1);transition:.5s -moz-transform cubic-bezier(.85,0,.15,1);transition:.5s -o-transform cubic-bezier(.85,0,.15,1);transition:.5s transform cubic-bezier(.85,0,.15,1)}a.jsx-1d2be9d99620c2cd>span:last-child{display:block!important}a.jsx-1d2be9d99620c2cd:hover>span,a.jsx-1d2be9d99620c2cd:focus>span{-webkit-transform:translateY(-100%);-moz-transform:translateY(-100%);-ms-transform:translateY(-100%);-o-transform:translateY(-100%);transform:translateY(-100%)}}@media(hover:hover)and (prefers-reduced-motion:reduce){a.jsx-1d2be9d99620c2cd>span{-webkit-transition-duration:0s;-moz-transition-duration:0s;-o-transition-duration:0s;transition-duration:0s}}@media(min-width:520px){ul.jsx-1d2be9d99620c2cd{margin-top:32px}}@media(max-width:520px){ul.jsx-1d2be9d99620c2cd{display:grid;grid-template-columns:repeat(3,1fr);-webkit-column-gap:24px;-moz-column-gap:24px;column-gap:24px;row-gap:12px}li.jsx-1d2be9d99620c2cd{aspect-ratio:1/1;display:grid;place-content:center;width:auto;height:auto}}@media(min-width:1250px){ul.jsx-1d2be9d99620c2cd{-webkit-box-pack:start;-webkit-justify-content:flex-start;-moz-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}}"
            })
        ]
    });
}
function Banner() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: styled_jsx_default().dynamic([
            [
                "b785db661b7448b7",
                [
                    tile.src
                ]
            ]
        ]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: styled_jsx_default().dynamic([
                    [
                        "b785db661b7448b7",
                        [
                            tile.src
                        ]
                    ]
                ]) + " " + "wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: styled_jsx_default().dynamic([
                            [
                                "b785db661b7448b7",
                                [
                                    tile.src
                                ]
                            ]
                        ]),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                            className: styled_jsx_default().dynamic([
                                [
                                    "b785db661b7448b7",
                                    [
                                        tile.src
                                    ]
                                ]
                            ]),
                            children: [
                                "Profiles in",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                    className: styled_jsx_default().dynamic([
                                        [
                                            "b785db661b7448b7",
                                            [
                                                tile.src
                                            ]
                                        ]
                                    ])
                                }),
                                "Climate Action"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: styled_jsx_default().dynamic([
                            [
                                "b785db661b7448b7",
                                [
                                    tile.src
                                ]
                            ]
                        ]),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: styled_jsx_default().dynamic([
                                    [
                                        "b785db661b7448b7",
                                        [
                                            tile.src
                                        ]
                                    ]
                                ]),
                                children: "Climate Leads are the internal champions driving decarbonization within companies. They do the work behind the scenes to mobilize businesses to solve climate change."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: styled_jsx_default().dynamic([
                                    [
                                        "b785db661b7448b7",
                                        [
                                            tile.src
                                        ]
                                    ]
                                ]),
                                children: "They\u2019re rethinking their businesses for a zero-carbon world, and working across far-flung teams to turn pledges into reality. They\u2019re optimistic and grounded, tenacious and resourceful. They\u2019re engineers, advocates, educators, and operators."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: styled_jsx_default().dynamic([
                                    [
                                        "b785db661b7448b7",
                                        [
                                            tile.src
                                        ]
                                    ]
                                ]),
                                children: "Their work really matters\u2014many manage more carbon than entire cities. At Watershed, we\u2019re lucky to support them every day."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: styled_jsx_default().dynamic([
                            [
                                "b785db661b7448b7",
                                [
                                    tile.src
                                ]
                            ]
                        ]),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TOC, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                className: styled_jsx_default().dynamic([
                    [
                        "b785db661b7448b7",
                        [
                            tile.src
                        ]
                    ]
                ]),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: textured_earth_full,
                    alt: "Illustration of earth",
                    priority: true,
                    objectFit: "cover",
                    objectPosition: "center bottom"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: styled_jsx_default().dynamic([
                    [
                        "b785db661b7448b7",
                        [
                            tile.src
                        ]
                    ]
                ]) + " " + "cut"
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "b785db661b7448b7",
                dynamic: [
                    tile.src
                ],
                children: "header.__jsx-style-dynamic-selector{background-color:#4b72e6;background-image:url(".concat(tile.src, ");-webkit-background-size:330px;-moz-background-size:330px;-o-background-size:330px;background-size:330px;position:relative;overflow:hidden;margin-top:-webkit-calc(-1*var(--nav-height));margin-top:-moz-calc(-1*var(--nav-height));margin-top:calc(-1*var(--nav-height))}.wrapper.__jsx-style-dynamic-selector{color:#fff;padding-top:-webkit-calc(96px + var(--nav-height));padding-top:-moz-calc(96px + var(--nav-height));padding-top:calc(96px + var(--nav-height));padding-bottom:96px;display:grid;position:relative;z-index:1}.wrapper.__jsx-style-dynamic-selector div.__jsx-style-dynamic-selector{padding-inline:24px}figure.__jsx-style-dynamic-selector{z-index:0;line-height:0;position:absolute;bottom:0;left:0;right:0}.cut.__jsx-style-dynamic-selector{background-color:#fff;width:100%;height:66px;position:absolute;bottom:-.5px;left:0;right:0;-webkit-clip-path:polygon(0 0,100%100%,100%100%,0%100%);clip-path:polygon(0 0,100%100%,100%100%,0%100%)}@media(min-width:520px)and (max-width:820px){.wrapper.__jsx-style-dynamic-selector{padding-bottom:160px}}@media(max-width:820px){figure.__jsx-style-dynamic-selector>span{min-height:300px}}@media(min-width:820px){.wrapper.__jsx-style-dynamic-selector{padding:128px 32px max(256px,33vh);grid-template-columns:repeat(2,minmax(0,1fr))}.wrapper.__jsx-style-dynamic-selector div.__jsx-style-dynamic-selector:first-child{text-align:right}.wrapper.__jsx-style-dynamic-selector div.__jsx-style-dynamic-selector:last-child{grid-column:span 2}h1.__jsx-style-dynamic-selector{font-size:64px}p.__jsx-style-dynamic-selector{max-width:54ch}.cut.__jsx-style-dynamic-selector{height:clamp(100px,18vh,150px)}}@media(min-width:1250px){.wrapper.__jsx-style-dynamic-selector{padding-bottom:max(384px,25vw)}.wrapper.__jsx-style-dynamic-selector div.__jsx-style-dynamic-selector:last-child{grid-column:2}}h1.__jsx-style-dynamic-selector{font-family:var(--font-family-serif);line-height:1}p.__jsx-style-dynamic-selector{color:inherit;font-size:18px;line-height:24px;font-weight:600;margin-bottom:24px}")
            })
        ]
    });
}
function Avatar(param) {
    var src = param.src, alt = param.alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: src,
                alt: alt,
                width: 160,
                height: 160,
                placeholder: "blur",
                className: "avatar",
                layout: "fixed"
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "ac7a0d472854c666",
                children: ".avatar{-webkit-border-radius:9999px;-moz-border-radius:9999px;border-radius:9999px}"
            })
        ]
    });
}
function NameAndTitle(param) {
    var name = param.name, title = param.title, company = param.company;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "jsx-f38099d57a972f0b",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "jsx-f38099d57a972f0b",
                children: name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "jsx-f38099d57a972f0b",
                children: [
                    title,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "jsx-f38099d57a972f0b",
                        children: [
                            ", ",
                            company
                        ]
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "f38099d57a972f0b",
                children: "div.jsx-f38099d57a972f0b{padding-bottom:16px}h2.jsx-f38099d57a972f0b{color:#000;font-family:var(--font-family-serif);font-size:32px;margin-bottom:0}p.jsx-f38099d57a972f0b{font-family:var(--font-family);font-size:18px;color:var(--color-medium-cobalt);font-weight:600;margin-bottom:0}@media(min-width:820px){span.jsx-f38099d57a972f0b{display:none}}"
            })
        ]
    });
}
function Section(param) {
    var id = param.id;
    var _id = companies[id], name = _id.name, person = _id.person;
    var Interview = person.interview;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        id: id,
        className: "jsx-529096e9cb47b03d" + " " + "container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                className: "jsx-529096e9cb47b03d",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar, {
                    src: person.avatar,
                    alt: person.name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Interview, {
                components: {
                    Header: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NameAndTitle, {
                            name: person.name,
                            title: person.role,
                            company: name
                        });
                    },
                    a: function(props) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", _objectSpread({
                            target: "_blank",
                            rel: "noreferrer noopener"
                        }, props, {
                            className: "jsx-529096e9cb47b03d" + " " + (props && props.className != null && props.className || "")
                        }));
                    }
                },
                className: "jsx-529096e9cb47b03d"
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "7dc872f24e46be38",
                children: "section.jsx-529096e9cb47b03d{display:grid;-webkit-column-gap:32px;-moz-column-gap:32px;column-gap:32px;row-gap:16px;margin-block:32px;scroll-margin-top:48px}section.jsx-529096e9cb47b03d:nth-of-type(odd){--color-highlight:#caf5ff}section.jsx-529096e9cb47b03d:nth-of-type(even){--color-highlight:#caffe8}section.jsx-529096e9cb47b03d:first-of-type{margin-top:-32px}@media(min-width:820px){section.jsx-529096e9cb47b03d{-webkit-column-gap:64px;-moz-column-gap:64px;column-gap:64px;margin-block:96px;scroll-margin-top:72px}section.jsx-529096e9cb47b03d:first-of-type{margin-top:-128px}section.jsx-529096e9cb47b03d:nth-of-type(odd){grid-template-columns:3fr 2fr}section.jsx-529096e9cb47b03d:nth-of-type(even){grid-template-columns:2fr 3fr}section.jsx-529096e9cb47b03d header,section.jsx-529096e9cb47b03d blockquote{grid-column:span 2}section.jsx-529096e9cb47b03d:nth-of-type(odd) aside{grid-column:2;grid-row:2}section.jsx-529096e9cb47b03d:nth-of-type(even) header{grid-column:2;grid-row:1}section.jsx-529096e9cb47b03d:nth-of-type(even) aside{grid-column:1;grid-row:2}section.jsx-529096e9cb47b03d:nth-of-type(even) article{grid-column:2}}@media(min-width:1100px){section.jsx-529096e9cb47b03d:first-of-type{margin-top:-160px}}@media(max-width:820px){section.jsx-529096e9cb47b03d:last-of-type{margin-bottom:0}}"
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "333cf9b906637d40",
                children: 'article h3{font-size:18px;margin-bottom:0}article p{color:#000;font-size:18px}aside p:last-child{margin-bottom:0}article~blockquote p{color:var(--color-core-cobalt);font-family:var(--font-family-serif);font-size:36px;line-height:1.25;max-width:none;margin:0}article~blockquote mark{background-color:var(--color-highlight);color:inherit}article~blockquote p:first-of-type{text-indent:-.7ch}article~blockquote p:first-of-type::before{content:"\u201C"}article~blockquote p:first-of-type::after{content:"\u201D"}@media(min-width:520px){article~blockquote{margin-top:48px}article~blockquote p{font-size:48px;letter-spacing:-.03em;line-height:1.25}}@media(max-width:520px){article~blockquote{padding-left:16px;padding-right:8px}}'
            })
        ]
    });
}
function PreviousCampaign() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "jsx-5b8c5a707d4735b1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/blog/earth-day-2021",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: "jsx-5b8c5a707d4735b1",
                    children: [
                        "2021 Climate Spotlight",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right/* default */.Z, {})
                    ]
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "5b8c5a707d4735b1",
                children: "div.jsx-5b8c5a707d4735b1{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;margin-bottom:48px}a.jsx-5b8c5a707d4735b1{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;text-align:center;text-decoration:none;background-color:#e0f0ff;color:#265cff;padding:16px;padding-right:32px;-webkit-border-radius:8px 0 0 8px;-moz-border-radius:8px 0 0 8px;border-radius:8px 0 0 8px;font-size:16px;line-height:1.375;-webkit-transition:.125s background-color ease-in-out;-moz-transition:.125s background-color ease-in-out;-o-transition:.125s background-color ease-in-out;transition:.125s background-color ease-in-out}a.jsx-5b8c5a707d4735b1:hover,a.jsx-5b8c5a707d4735b1:focus{background-color:#c6ddff}a.jsx-5b8c5a707d4735b1 svg{stroke:currentColor}@media(min-width:820px){div.jsx-5b8c5a707d4735b1{margin-top:48px}}"
            })
        ]
    });
}
function EarthDayPage() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(meta/* default */.Z, {
                title: "Climate Leads: Profiles in Climate Action",
                description: "Honoring Climate Leads, the internal champions driving impact within companies.",
                image: "https://watershed.com/img/climate-leads.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar/* default */.Z, {
                sticky: true,
                translucent: true,
                linkColor: "#fff"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                className: "jsx-6b1eb4e8ddc33ed8",
                children: Object.keys(companies).map(function(co) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
                        id: co
                    }, co);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviousCampaign, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* default */.Z, {}),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "9078a5ce5e26503c",
                children: "main.jsx-6b1eb4e8ddc33ed8{padding-inline:4px;padding-block:0}@media(min-width:520px){main.jsx-6b1eb4e8ddc33ed8{padding-inline:12px}}@media(min-width:820px){main.jsx-6b1eb4e8ddc33ed8{padding-inline:20px}}"
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "19e495dc5181ca86",
                children: ':root{--font-family-serif:"Mackinac Pro", ui-serif, Georgia, serif;--color-medium-cobalt:#5d93ff;--color-core-cobalt:#3366ff;--color-deep-cobalt:#0033cc;--container-width:1024px}@font-face{font-family:"Mackinac Pro";src:url("/fonts/P22MackinacProBook.eot");src:url("/fonts/P22MackinacProBook.eot?#iefix")format(url("embedded-opentype")),url("/fonts/P22MackinacProBook.woff")format(url("woff")),url("/fonts/P22MackinacProBook.svg")format(url("svg"));src:url("/fonts/P22MackinacProBook.eot?#iefix")format("embedded-opentype"),url("/fonts/P22MackinacProBook.woff")format("woff"),url("/fonts/P22MackinacProBook.svg")format("svg");font-weight:normal;font-style:normal}@font-face{font-family:"Mackinac Pro";src:url("/fonts/P22MackinacProMedium.eot");src:url("/fonts/P22MackinacProMedium.eot?#iefix")format(url("embedded-opentype")),url("/fonts/P22MackinacProMedium.woff")format(url("woff")),url("/fonts/P22MackinacProMedium.svg")format(url("svg"));src:url("/fonts/P22MackinacProMedium.eot?#iefix")format("embedded-opentype"),url("/fonts/P22MackinacProMedium.woff")format("woff"),url("/fonts/P22MackinacProMedium.svg")format("svg");font-weight:bold;font-style:normal}'
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [109,89,854,774,888,179], function() { return __webpack_exec__(5811); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);